import React, { FC } from "react";
import { useFormState } from "react-final-form";
import { IWizardStepContent } from "../../../../wizard/types";
import PreviewProgram from "../../components/step5/PreviewProgramHigher";

const Content: FC<IWizardStepContent> = ({ handleSubmit }) => {
  const { values } = useFormState();

  return (
    <form noValidate onSubmit={handleSubmit}>
      <PreviewProgram {...values.injectedData.data} />
    </form>
  );
};

export default Content;
